import { CButton, CImg, CLabel, CModal, CModalBody, CModalFooter } from '@coreui/react';
import * as React from 'react';
import RichTextEditor from 'react-rte';
import SunEditor from 'suneditor-react';
import SetOptions from 'suneditor-react/dist/types/SetOptions';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { IImageProvider } from '../../abstraction';
import { AppLabels } from '../../core/AppLabels';
import { Utils } from '../../core/utils';


interface IControlHTMLModel {
	Class: string;
	Content: string;
	Description: string;
	InlineStyle: string;
	ShowHeader?: boolean;
	Key: string;
	ShowMoreIcon: string;
	Visible: boolean;
}

interface IProps {
	bsSize: string;
	imageProvider: IImageProvider;
	control: IControlHTMLModel;
	ShowMoreOnLoad: boolean;
}

interface IState {
	isOpen: boolean;
	showOnLoad: boolean;
	value: any;
}

export class KControlHTMLViewer extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.editor = React.createRef();
		
		this.state = {
			isOpen: false,
			showOnLoad: this.props.ShowMoreOnLoad,
			value: RichTextEditor.createEmptyValue()
		}
	}

	private editor: any;

	//#region Local events 

	componentDidUpdate = () => {
		if (this.state.showOnLoad == true) {
			if ((this.props.control.Content != "") && (this.props.control.Content != "")) {
				this.setState({
					isOpen: true,
					showOnLoad: false
				});
			}
		}
	}

	toggle = () => {
		this.setState({ isOpen: !this.state.isOpen });
	}
	//#endregion 

	//#region Rendus

	createMarkup = () => {
		return { __html: this.props.control.Content };
	}

	

	renderInput = () => {
		let ctrl = this.props.control;
		let a: SetOptions = {
			 
		}
		if (ctrl.Content) {
			if (ctrl.ShowMoreIcon)
				return <div><CImg onClick={this.toggle} src={this.props.imageProvider.getImg(ctrl.ShowMoreIcon)} /></div>
			return <div className="form-control HTMLContent" ><div dangerouslySetInnerHTML={this.createMarkup()} onClick={this.toggle} ></div></div>
		}
		return "";
	}

	render() {
		let ctrl = this.props.control;

		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);

		let ctrlInput = this.renderInput();
		let header = ctrl.ShowHeader == false ? "" : <CLabel htmlFor={ctrl.Key} >{ctrl.Description}</CLabel>;
			return (
				<div className={`KControl KControlHTML ${ctrl.Class} ${this.props.bsSize}`} style={inlineStyle} >

					{header}
					{ctrlInput}

					<CModal centered closeOnBackdrop={false} className={"KContentFullscreen "} show={this.state.isOpen} onClose={() => this.toggle()} >
						<CModalBody >
							<div className="form-control HTMLContent" ><div dangerouslySetInnerHTML={this.createMarkup()} onDoubleClick={this.toggle} ></div></div>
						</CModalBody>
						<CModalFooter>
							<CButton color="primary" onClick={this.toggle}>{AppLabels.close}</CButton>{' '}
						</CModalFooter>
					</CModal>
				</div>
			)
		
	}
	//<CInput onClick={this.toggle} className="input" readOnly={true} type="textarea" name={ctrl.Key} color=" default" value={ctrl.Content} onDoubleClick={this.toggle} />
	//#endregion
}